export default {"src":"/_next/static/media/transit-train.336cdef3.svg","height":18,"width":16,"blurWidth":0,"blurHeight":0};